var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.start && _vm.displayLoader)?_c('div',{staticClass:"preloader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/PEDDLR-GIF-200x50.gif"),"alt":""}})])
}]

export { render, staticRenderFns }